/* eslint-disable */
import { computed, ref, watch } from '@vue/composition-api'
import { concat, debounce } from 'lodash'
import MessageItem from '../MessageItem/MessageItem.vue'
import NewMessageForm from '../NewMessageForm/NewMessageForm.vue'
import useRequest from '@/compositions/useRequest'

export default {
  components: {
    NewMessageForm, MessageItem,
  },
  props: {
    loading: Boolean,
    orderId: String,
    messages: Array,
    heightDiff: String,
  },
  setup(props, context) {
    const { root } = context
    const { $store } = root

    // intersection observe
    const messageContainer = ref(null)
    const messageItem = ref([])
    const lastMessageAnchor = ref(null)
    const readByUser = new Set()
    let observer

    const updateRead = () => {
      Array.from(readByUser).forEach((id) => {
        const message = props.messages.find(item => item.id === Number(id))
        message.isRead = true
      })
      readByUser.clear()
    }

    const { makeRequest: setMessagesRead } = useRequest({
      request: data => $store.dispatch('driver/postMessagesRead', { orderId: props.orderId, messageId: data.messageId }),
      successCallback: updateRead,
      context,
    })

    const sendRead = (messageId) => {
      setMessagesRead({messageId})
    }

    const styleHeight = computed(() => ({
      height: 'calc(100vh - 30rem)',
      minHeight: '40rem',
    }))

    watch(() => messageItem.value, () => {
      if (lastMessageAnchor.value) lastMessageAnchor.value.scrollIntoView({ block: 'end' })
      if (observer) {
        const observable = concat([], messageItem.value)
        observable.forEach((item) => {
          observer.observe(item.$el)
        })
      }
    })

    const hanldeInView = (item) => {
      if (!item.yours && !item.isRead) {
        sendRead(item.id)
      }
    }

    return {
      styleHeight,
      messageItem,
      messageContainer,
      lastMessageAnchor,
      hanldeInView,
    }
  },
}
